import * as S from "./styles";
import { useDbFunctions, useEvents } from "@/talons";
import { ModalSync } from "@/components";
import { useCallback, useMemo, useState } from "react";
import versionHistory from "@/constants/version-history.json"
import { useGlobals, useNetworkStatusContext } from "@/hooks";
import { unregisterServiceWorker } from "@/shared/serviceWorkFunctions";
import ModalVersionHistory from "@/components/modal-version-history/ModalVersionHistory";

type Props = {
  showInfos?: boolean
}

const InfosVersion = ({ showInfos = true }:Props) => {
  const db = useDbFunctions();
  const [isOpenModal, setModalState] = useState(false);
  const { connectivityStatus } = useNetworkStatusContext();
  const { lastSync, version, lastCheckedVersion, setLastCheckedVersion } = useGlobals();
  const { registerEvent } = useEvents(db);

  const showDot = useMemo(() => {
    return lastCheckedVersion !== version && version === versionHistory.version
  }, [lastCheckedVersion, version])

  const handleOpenVersionHistoryModal = useCallback(() => {
    setModalState(true)
    setLastCheckedVersion(version)
  }, [setModalState, setLastCheckedVersion, version]);

  return (
    <>
      <S.Container>
        {showInfos && <S.InfosContent>
          <S.MomentContent>
            <S.CalendarScheduleLine size={21} />

            <S.MomentData>
              <S.SyncLabel>Última sincronização</S.SyncLabel>
              <S.LastSync>{lastSync}</S.LastSync>
            </S.MomentData>
          </S.MomentContent>

          <S.Container>
            <ModalSync>
              <S.SyncButton>
                <S.SyncButtonIcon size={21} />
                <S.SyncButtonLabel>Sincronizar</S.SyncButtonLabel>
              </S.SyncButton>
            </ModalSync>
          </S.Container>
        </S.InfosContent>}

        <S.VersionContent className="version-content">
          <S.LineVersion>
            <S.Version $redDot={showDot} onClick={async () => {
              registerEvent({
                tipoEvento: 'SINC_VERSAO',
                obsEvento: `Sincronização de versão ${version} iniciada`,
              });

              if (connectivityStatus === 'offline') return alert('Ação permitida somente online.')
              if (version !== versionHistory.version) {
                await unregisterServiceWorker({})
                window.location.reload();
              } else {
                handleOpenVersionHistoryModal();
              }
            }}>Versão {version}</S.Version>
          </S.LineVersion>
        </S.VersionContent>
      </S.Container>

      <ModalVersionHistory isOpenModal={isOpenModal} setModalState={setModalState} />
    </>
  );
};

export default InfosVersion;
